import { Expose } from 'class-transformer'

export class ShipstationOrder {
  static type = 'shipstationorder'

  type = ShipstationOrder.type

  @Expose({ name: 'order_number' })
  orderNumber?: string

  @Expose({ name: 'shipstation_id' })
  shipstationId?: number
}
